import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

export const authGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const authService = inject(AuthServiceLocal);

  const userToken = localStorage.getItem('PWAToken');
  if (userToken) {
    return true;
  }

  const userId = route.queryParamMap.get('userId');
  if (!userId) {
    router.navigate(['/auth/login']);
    return true;
  }

  const res = await authService.getCustomerDetails({ userId });
  if (!res) {
    router.navigate(['/auth/login']);
  }
  return true;
};
